<template>
	<b-container class="show-document">
		<div class="doc-body">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i>
						{{ $t('back') }}
					</b-button>
				</div>
				<div class="pull-right">
					<b-button
						variant="outline-dark"
						class="mr-2"
						@click="print"
					>
						<i class="fa fa-print"></i>
						Печать Штрихкод
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<b-modal
				:hide-header="true"
				v-model="confirmBackToBarcode"
				:no-close-on-esc="true"
				:no-close-on-backdrop="true"
				@ok=""
				size="md"
			>
				<h1> У вас нет доступа к этому товару!</h1>

				<div slot="modal-footer">
					<b-button
						variant="success"
						size="sm"
						class="float-right ml-2"
						@click="goBackToFrom"
					>
						OK
					</b-button>

				</div>


			</b-modal>
			<div>
				<div class="printElement text-center mt-4" v-for="n in count">
<!--					<p class="text-center info"><b>DUTY FREE</b></p>-->
<!--					<p style="font-size: 15px"><b>{{ShopName}}</b></p>-->
					<p class="text-center info"><b>{{item.barcode}}</b> <b v-if="item.priceUzs!==0" class="ml-2">$ - {{ item.priceUzs }} EUR</b><br/></p>
					<p class="text-center info"> {{ item.itemName }} <br/></p>
<!--					<p class="text-center prices"><b>Culoare: </b>{{item.color}}</p>-->
					<barcode :value="item.multiBarcode" :options="{ height: '50px',displayValue: false}" tag="svg"></barcode>
					<p style="font-size: 16px" class="barcode"><b>{{ item.multiBarcode }}</b></p>
<!--					<p class="text-center prices" style="font-size: 20px"><b>{{ itemPrice[0].priceUzs | currency({ symbol: userDepCurrencyName, fractionCount: 0, symbolPosition: 'back', thousandsSeparator: '.' }) }}</b></p>-->
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
import {mapState} from 'vuex'
import PricesService from "../../../../services/prices.service";

export default {
	name: 'BarcodeGenerate',
	data() {
		return {
			item: {
				name: ''
			},
			name: '',
			count: 0,
			itemPrice: [
				{priceUzs: 0}
			],
			confirmBackToBarcode: false,
			noError: true,


		}
	},
	computed: {
		...mapState(['userDepCurrencyName']),
		ShopName() {
			return JSON.parse(localStorage.getItem('TavarName'))
		},
	},

	methods: {
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';

			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		},
		async get() {
			let barcode = this.$route.params.id,
				itemId = this.$route.params.itemId,
				depId = this.$route.params.depId;
			this.count = parseInt(this.$route.params.count);
			let link = '?barcode=' + barcode + '&itemId=' + itemId;
			if (depId != 'null')
				link+=`&depId=${depId}`
			await PricesService.getItemByPrice(link).then(response => {
				if (response) {
					this.item = response.data
				} else {
					this.noError = false;
					// this.confirmBackToBarcode = true;
				}
			}).catch(error => {
				// this.confirmBackToBarcode = true;
			})
		},
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			// var printContents = document.getElementById('printElement').innerHTML;
			// var originalContents = document.body.innerHTML;
			//
			// document.body.innerHTML = printContents;
			await this.removePageSizeStyle();
			await this.setPageSizeStyle('landscape');
			window.print();
			//
			// document.body.innerHTML = originalContents;
			//
			// var printContents = document.getElementById('printElement').innerHTML;
			// var originalContents = document.body.innerHTML;
			// document.body.innerHTML = printContents;
			// window.print();
			// document.body.innerHTML = originalContents;
		}
	},
	async created() {
		await this.get()
	},
	beforeRouteEnter(to, from, next) {
		let current = this
		if (from.path === '/warehouse-management/goods') {
			next(vm => {
				vm.prevRoute = from
			})
		} else {
			next('/warehouse-management/goods');
		}
		next(vm => {
			vm.prevRoute = from
		})


	},

}
</script>

<style scoped>
body {
	background-color: white !important;
}

@page {
	margin: 0 !important;
}

@media print {
	html, body {
		margin: 0 !important;
		text-align: center;
		padding: 0 !important;
	}

	/* @page { size: landscape; } */
	.hidden-print {
		display: none;
	}

	.printElement {
		margin-top: 1% !important;
		margin-bottom: 0 !important;
		margin-left: 2.5% !important;
		text-align: center;
		page-break-after: always;
		word-break: break-all;
		width: 70mm !important;
		height: 35mm !important;
		color: #000;
	}

	.printElement p {
		width: 100%;
		font-family: "Arial Black", Gadget, sans-serif;
		text-align: center;
		color: #000000 !important;
		font-weight: bold;
		page-break-inside: avoid;
	}

	.info {
		font-size: 12px !important;
	}

	.card {
		box-shadow: none;
	}

	svg {
		width: 65mm !important;
		/*margin-top: -1mm;*/
		position: relative;
		bottom: 0;
		left: 0;
	}

	.prices {
		font-size: 15px !important;
	}

	.barcode {
		position: relative;
		font-size: 80px;
	}
}


p {
	margin-bottom: 0px;
	font-size: 14px;
}

.printElement svg {
	width: 65mm;
	height: 20mm;
}


</style>
